import { join } from './strings';

type RouteTree<T> = {
    [P in keyof Omit<T, 'path'>]: T[P] extends RouteTree<T[P]> ? T[P] : never;
} & { path: string };

function routeTree<T>(root: RouteTree<T>, parentPath = ''): RouteTree<T> {
    const { path, ...children } = root;
    const treePath = join([parentPath, path], '/').replace(/\/+/g, '/');
    const parsedChildren = Object.entries(children).reduce(
        (acc, [key, child]) => ({
            ...acc,
            [key]: routeTree(child as { path: string }, treePath),
        }),
        {}
    );
    return {
        ...parsedChildren,
        path: treePath,
    } as RouteTree<T>;
}

export { routeTree };
export type { RouteTree };
